import { getEStampAllConfig } from '../../../api';
import { defineStore } from 'pinia';
import { to } from '@tencent/wphk-components-common/utils/common';
import { ref, onMounted } from '@vue/composition-api';
import { CustomException, language } from '@tencent/ppd-base-libs';

export const useNoticeMessage = defineStore('noticeMessage', () => {
  const message = ref('');

  onMounted(async () => {
    const lang = language.getLanguage();
    const [err, res] = await to(getEStampAllConfig());
    if (err) {
      throw new CustomException(err, 'eStampNoticeMessageFail', '新版狂赏印加载印花记录通知消息配置失败');
    }

    const { recordNotice = [] } = res;
    const firstNotice = recordNotice[0] || {};

    if (lang === 'en') {
      const msg = firstNotice.messageEn || '';
      message.value = msg;
    } else if (lang === 'zh-hk') {
      const msg = firstNotice.messageZh || '';
      message.value = msg;
    } else if (lang) {
      const msg = firstNotice.messageHk || '';
      message.value = msg;
    }
  });

  return { message };
});
